import { Observable } from "rxjs";

import { Alias, DataStoreOptions, LinkOperator, RequestCriteriaResourceInputInterfaceTypes, SearchQuery, SearchResponse } from "@skinsoft/types";
import { SEARCH_TYPES } from "@skinsoft/const";

import { AliasDataStore } from "@skinsoft/entity";
import { CACHE_KEYS, AliasOfflineDataFetcher } from "@skinsoft/offline";
import { EntitySyncDownHandler } from "../../entity-sync-down-handler";

declare const config
const SEARCH_PAGE_SIZE = config.syncDownPageSize.alias ?? config.syncDownPageSize.default

const AUTHOR_TAG_ID = "595ca6a7857ababbc1abcd16"
const COLLABORATOR_TAG_ID = "591ca6a8857aca1231abcd4e"
const OWNER_TAG_ID = "595ca6a7857ababbc1abcd1d"

export class AliasSyncDownHandler extends EntitySyncDownHandler<Alias, Alias, Alias> {
    private static instance: AliasSyncDownHandler = null as any

    public static getInstance() {
        if (!AliasSyncDownHandler.instance) {
            AliasSyncDownHandler.instance = new AliasSyncDownHandler()
        }

        return AliasSyncDownHandler.instance
    }

    public static install(Vue) {
        AliasSyncDownHandler.getInstance()
    }

    constructor() {
        super(
            [SEARCH_TYPES.alias],
            AliasDataStore.getInstance(),
            new AliasOfflineDataFetcher(),
            CACHE_KEYS.Alias,
            SEARCH_PAGE_SIZE,
        )
    }

    sendSynchroDownRequest(searchQuery: SearchQuery, options: DataStoreOptions): Observable<SearchResponse<Alias>> {
        const updatedSearchQuery: SearchQuery = {...searchQuery};

        try {
            const tagsCriterias = (this.dataStore as AliasDataStore).getTagsCriteria([
                AUTHOR_TAG_ID,
                COLLABORATOR_TAG_ID,
                OWNER_TAG_ID
            ])
    
            if(updatedSearchQuery.advancedSearches?.length) {
                (updatedSearchQuery as any).advancedSearches[0].rightCriteria = (updatedSearchQuery as any).advancedSearches[0].leftCriteria
                (updatedSearchQuery as any).advancedSearches[0].leftCriteria = tagsCriterias;
                (updatedSearchQuery as any).advancedSearches[0].linkOperator = LinkOperator.AND;
                (updatedSearchQuery as any).advancedSearches[0].type = RequestCriteriaResourceInputInterfaceTypes.REQUEST_SEARCH
            } else {
                updatedSearchQuery.advancedSearches = [tagsCriterias]
            }
        } catch(err) {
            
        }

        return super.sendSynchroDownRequest(updatedSearchQuery, options)
    }
}